import PropTypes from 'prop-types';
import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
// material
import { Card, CardHeader, Box, IconButton, Tooltip } from '@material-ui/core';
import { Icon } from '@iconify/react';
import downloadFill from '@iconify/icons-eva/download-fill';

import { useTranslation } from 'react-i18next';
import { BaseOptionChart } from './charts';

function MultiChart({
  title,
  subtitle,
  seriesLabels,
  dataSeries,
  labels,
  yLabel,
  isPercentage,
  dataTooltip
}) {
  const { t } = useTranslation();

  const handleDownload = () => {
    // Create CSV content
    // const headers = ['Date', seriesLabel];
    // const rows = labels.map((label, index) => [label, dataSeries[index]]);
    // const csvContent = [headers.join(','), ...rows.map((row) => row.join(','))].join('\n');
    // // Create and trigger download
    // const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    // const link = document.createElement('a');
    // const url = URL.createObjectURL(blob);
    // link.setAttribute('href', url);
    // link.setAttribute('download', `${title.toLowerCase().replace(/\s+/g, '_')}_data.csv`);
    // link.style.visibility = 'hidden';
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
  };

  function getChartData(dataSeries, seriesLabels) {
    return dataSeries.map((series, i) => ({
      name: seriesLabels[i],
      type: 'area',
      data: series
    }));
  }

  const CHART_DATA = getChartData(dataSeries, seriesLabels);

  const chartOptions = merge(BaseOptionChart(), {
    stroke: { width: [2] },
    plotOptions: { bar: { columnWidth: '11%', borderRadius: 4 } },
    // repeat the gradient for each series
    fill: { type: dataSeries.map(() => 'gradient') },
    labels: [...labels],
    xaxis: { type: 'datetime' },
    yaxis: [
      {
        title: {
          text: yLabel
        },
        labels: {
          formatter: (y) => {
            if (isPercentage) {
              if (typeof y !== 'undefined') {
                return `${(y.toFixed(2) * 100).toFixed(0)}%`;
              }
              return y;
            }
            return y;
          }
        }
      }
    ],
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (y, { dataPointIndex }) => {
          if (dataTooltip && dataTooltip[dataPointIndex] !== undefined) {
            return dataTooltip[dataPointIndex];
          }
          if (isPercentage) {
            if (typeof y !== 'undefined') {
              return `${(y.toFixed(2) * 100).toFixed(0)}%`;
            }
            return y;
          }
          return null;
        }
      }
    }
  });

  console.log('MultiChart', title, CHART_DATA, labels);

  return (
    <Card>
      <CardHeader
        title={title}
        subheader={subtitle}
        action={
          <Tooltip title={t('general.download_data')}>
            <IconButton onClick={handleDownload}>
              <Icon icon={downloadFill} />
            </IconButton>
          </Tooltip>
        }
      />
      <Box sx={{ p: 3, pb: 1 }} dir="ltr">
        <ReactApexChart type="line" series={CHART_DATA} options={chartOptions} height={364} />
      </Box>
    </Card>
  );
}

MultiChart.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  seriesLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
  isPercentage: PropTypes.bool,
  // dataSeries is an array of arrays of numbers
  dataSeries: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired,
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  yLabel: PropTypes.string.isRequired,
  dataTooltip: PropTypes.arrayOf(PropTypes.string)
};

MultiChart.defaultProps = {
  subtitle: '',
  dataTooltip: []
};

export default MultiChart;
